module.exports = __webpack_public_path__ + "img/bg_002.fecbfc19.png";